import { forEach, groupBy, head, isNil, join } from 'lodash-es';
import moment from 'moment';
import qs from 'qs';
import Vue from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';
import Datepicker from 'vuejs-datepicker';
import DeliveryStatus from '../../components/deliveryStatus';
import GoogleMaps from '../../components/googleMaps';
import MainButtonSet from '../../components/mainButtonSet';
import ScheduledDeliveryDate from '../../components/scheduled-delivery-date';
import StageHeader from '../../components/stageHeader';
import TmsDatepicker from '../../components/tmsDatepicker';
import UinsDefaultSelect from '../../components/unisDefaultSelect';
import UnisProductModal from '../../components/unisProductModal';
import tmsServiceBackend from '../../services/axios/tmsServiceBackend';
import util from '../../shared/util';
import template from './trackingGuest.vue';

Component.registerHooks(['beforeRouteEnter', 'beforeRouteLeave', 'beforeRouteUpdate']);
@Component({
    mixins: [template],
    components: {
        Datepicker,
        StageHeader,
        MainButtonSet,
        UinsDefaultSelect,
        UnisProductModal,
        GoogleMaps,
        DeliveryStatus,
        TmsDatepicker,
        ScheduledDeliveryDate,
    },
})
export default class TrackingGuest extends Vue {
    @Prop({ default: '' })
    orderId: any;

    @Prop({ default: '' })
    querymodle: any;

    @Prop({ default: '' })
    searchInfo: any;

    isLogin: boolean = false;
    showTageNames: Array<any> = [];
    historys: any = {};
    trackedShipment: any = {};
    deliveryStages: number = 0;
    perOrderId: any = '';
    searchText: any = '';
    searchTrackText: any = '';
    showErrTip: boolean = false;
    errorText: String = '';
    specialInstructions: any = '';
    desiredDeliveryDate: any = '';
    after: any = '';
    before: any = '';
    subject: any = '';
    describeTheIssue: any = '';
    trackingNo: any = {};
    showActivity: any = {};
    userSource: boolean = false;
    place: any = null;
    setmarkers: Array<any> = [
        {
            lat: 33.966324,
            lng: -118.242134,
            state: 'finish',
        },
    ];
    setCenter: any = {
        lat: 33.966324,
        lng: -118.242134,
    };

    resChoosingUNIS: any = 'resChoosingUNIS';
    isBusinessType: Boolean = false;
    ReturnToList: any = 'Return to invoice List';
    isShowWalkthrough: Boolean = false;
    ishideMapRoute: Boolean = false;
    deliveryStagesLine: any = 0;
    editContactUnisSupport: any = 'contactSupport';
    editSchedulEdeliveryAppointment: any = 'schedulEdeliveryAppointment';
    sendContactSupportNumber: any = 0;
    isLoading = false;

    @Watch('orderId')
    getOrderId(val: any, oldVal: any) {
        if (val) {
            this.getTrackShipment(val);
        }
    }
    @Watch('searchInfo')
    getSearchInfo(val: any, oldVal: any) {
        if (val) {
            this.searchTrackText = val;
        }
    }

    async getTrackShipment(orderId: any) {
        try {
            this.isLoading = true;
            await this.trackShipment(orderId, 'mounted');
            this.isLoading = false;
        } catch (error) {
            this.isLoading = false;
        }
    }

    showErrorFun(errText: any) {
        this.errorText = errText;
        this.showErrTip = true;
        setTimeout(() => {
            this.showErrTip = false;
        }, 3000);
    }

    created() {}

    clickFold(tag: string) {
        if (this.showTageNames.indexOf(tag) > -1) {
            this.showTageNames.splice(this.showTageNames.indexOf(tag), 1);
        } else {
            this.showTageNames.push(tag);
        }
    }

    async mounted() {
        this.isLogin = isNil(localStorage.getItem('UserID')) ? false : true;
        this.getTrackShipment(this.orderId);
        this.searchTrackText = this.searchInfo;
        /*try {
        let userSource = localStorage.getItem("userSource");
        if (userSource && (userSource == 'self sign up without account code' || userSource == 'google' || userSource == 'facebook')) this.userSource = true;
        this.isBusinessType = (localStorage.getItem("businessType") == 'true') ? true : false;
        let guideDoneStage = localStorage.getItem("guideDoneStage");
        let guideDoneStageNumber = Number(localStorage.getItem("guideDoneStageNumber"));
        if (this.isBusinessType && guideDoneStage && guideDoneStage == 'finished' && guideDoneStageNumber < 3) {
          this.$modal.show(this.resChoosingUNIS);
          localStorage.setItem("guideDoneStage", '');
        }
        let orderId: any = '';
        let trackingNo: any = '';
        if (this.$route.query && this.$route.query.searchText) {
          orderId = this.$route.query.searchText;
          this.searchText = this.$route.query.searchText;
          this.searchTrackText = this.$route.query.searchText;
        } else {
          orderId = localStorage.getItem("TrackShipmentOrder");
          trackingNo = localStorage.getItem("TrackShipmentTrackingNo");
          this.querymodle = localStorage.getItem("TrackShipmentQuerymodle");
        }
        if (orderId) {
          this.perOrderId = orderId;
        } else if (trackingNo) {
          this.trackingNo = trackingNo;
        }



        this.isLoading = true;
        await this.trackShipment(this.perOrderId, 'mounted');
        this.isLoading = false;
      } catch (error) {
        this.isLoading = false;
      }*/
    }

    onTrack() {
        this.$emit('chargeTrack', this.searchTrackText);
    }

    private trackShipment(searchText: any, mounted: any) {
        return tmsServiceBackend
            .get(`/cpv2/tracking/track?order_id=${searchText}&request_from=V2`)
            .then(
                (res: any) => {
                    if (res.data.status == 0) {
                        this.showErrorFun(res.data.message);
                        return;
                    }
                    let data = res.data.data;
                    this.trackedShipment = head(data);
                    this.fillTrackedShipment();
                    this.setmarkers = [];
                    if (this.trackedShipment.pickup_lat && this.trackedShipment.pickup_lng) {
                        this.setmarkers.push({
                            total_Miles: this.trackedShipment['total_Miles'],
                            locationState: this.trackedShipment['pickup_state'],
                            city: this.trackedShipment['pickup_city'],
                            lat: parseFloat(this.trackedShipment.pickup_lat),
                            lng: parseFloat(this.trackedShipment.pickup_lng),
                            state: 'continuous',
                        });
                    }
                    if (this.trackedShipment.delivery_lat && this.trackedShipment.delivery_lng) {
                        this.setmarkers.push({
                            total_Miles: this.trackedShipment['total_Miles'],
                            locationState: this.trackedShipment['delivery_state'],
                            city: this.trackedShipment['delivery_city'],
                            lat: parseFloat(this.trackedShipment.delivery_lat),
                            lng: parseFloat(this.trackedShipment.delivery_lng),
                            state: 'finish',
                        });
                    }
                    this.setCenter = {
                        lat: parseFloat(this.trackedShipment.delivery_lat),
                        lng: parseFloat(this.trackedShipment.delivery_lng),
                    };
                    if (this.trackedShipment.pictures && this.trackedShipment.pictures.length > 0)
                        forEach(this.trackedShipment.pictures, (item: any) => {
                            if (item.file_category_name == 'CONF_RATE')
                                this.$set(item, 'fileName', 'LOA');
                            if (item.file_category_name == 'INSP_CERT')
                                this.$set(item, 'fileName', 'W&I');
                        });
                    if (this.trackedShipment.manifest_data && this.trackedShipment.manifest_data.length > 0) {
                        this.trackedShipment.custRef = this.trackedShipment.manifest_data
                            .filter((item: any) =>
                                item.cust_ref &&
                                typeof item.cust_ref === 'string' &&
                                item.cust_ref.trim() !== ''
                            )
                            .map((item: any) => item.cust_ref)
                            .join(',');
                    }
                },
                (err: any) => {
                    this.showErrorFun(err.response.data.statusText);
                }
            );
    }

    goToLogoIn() {
        window.location.href = '#/';
    }

    private fillTrackedShipment() {
        if (this.trackedShipment.d_date2) {
            let time = moment(this.trackedShipment.d_date2).format('LLLL');
            let timeArray = time.split(',');
            this.trackedShipment['scheduledDelivery'] = join(timeArray.slice(0, 2), ',');
        }
        forEach(this.trackedShipment.histories, history => {
            let time = moment(history.tms_order_log_created_date).format('LLLL');
            let year = moment(history.tms_order_log_created_date).format('YYYY');
            let timeArray = time.split(',');
            history['groupName'] = join(timeArray.slice(0, 2), ',') + ',' + year;
            let cDateYear = history.c_date ? moment(history.c_date).format('MM/DD/YYYY') : '';
            let cDateTime = history.c_date ? moment(history.c_date).format('HH:mm A') : '';
            history['cDateYear'] = cDateYear;
            history['cDateTime'] = cDateTime;
        });
        this.historys = groupBy(this.trackedShipment.histories, 'groupName');
        forEach(this.historys, (activity, key) => {
            if (activity.length > 0) {
                forEach(activity, item => {
                    if (
                        item.tms_order_log_text1 == 'Pickup Dispatched' ||
                        item.tms_order_log_text1 == 'Pickup Completed' ||
                        item.tms_order_log_text1 == 'Linehaul Completed' ||
                        item.tms_order_log_text1 == 'Linehaul Dispatched' ||
                        item.tms_order_log_text1 == 'Delivery Dispatched' ||
                        item.tms_order_log_status_code == 'Current Location' ||
                        item.tms_order_log_text1 == 'Delivery Completed'
                    ) {
                        this.showActivity[key] = true;
                        return;
                    }
                });
            }
        });
        this.getProgressImage(this.trackedShipment.stage, this.trackedShipment.status);
    }

    private getProgressImage(shipmentStage: any, shipmentStatus: any) {
        if (shipmentStatus == 4 && shipmentStage == 5) {
            // Invoiced
            this.deliveryStages = 5;
            this.deliveryStagesLine = 100;
        } else if (shipmentStage == 5 && shipmentStatus > 0) {
            // Delivered
            this.deliveryStages = 4;
            this.deliveryStagesLine = 100;
        } else if (shipmentStage == 4 && shipmentStatus > 0) {
            // Out for Delivery
            this.deliveryStages = 3;
            this.deliveryStagesLine = 75;
        } else if (shipmentStage == 1 || shipmentStage == 2 || shipmentStage == 3) {
            // Picked Up
            this.deliveryStages = 2;
            this.deliveryStagesLine = 50;
        } else if (shipmentStage == 0 && shipmentStatus > 1) {
            // In Process
            this.deliveryStages = 2;
            this.deliveryStagesLine = 50;
        } else if (shipmentStage == 0 && shipmentStatus == 1) {
            // Order created
            this.deliveryStages = 1;
            this.deliveryStagesLine = 10;
        } else {
            // Empty
        }

        this.$forceUpdate();
    }

    restartWalkthrough() {
        let stageNumber = localStorage.getItem('guideDoneStageNumber');
        if (stageNumber) {
            if (stageNumber && Number(stageNumber) == 2)
                tmsServiceBackend.post(`/cpv2/userGuide/increaseShowTimes`);
            localStorage.setItem('guideDoneStageNumber', String(Number(stageNumber) + 1));
        } else localStorage.setItem('guideDoneStageNumber', '1');
        this.$modal.hide(this.resChoosingUNIS);
        localStorage.setItem('guideDoneStage', 'Dashboard');
        this.$router.replace({
            name: 'Home',
        });
        util.showUserWalkthrough();
    }

    closeandreturntodashboard() {
        localStorage.setItem('guideDoneStageNumber', '3');
        localStorage.setItem('guideDone', 'true');
        this.$modal.hide(this.resChoosingUNIS);
        this.$router.replace({
            name: 'Home',
        });
    }

    doNotShowUserWalkthrough(isShowWalkthrough: any) {
        if (!isShowWalkthrough) {
            tmsServiceBackend.post(`/cpv2/userGuide/complete`).then(
                (res: any) => {
                    // this.showUpdated({title: 'Update', mag: 'Is not show user walkthrough on next login !'});
                    localStorage.setItem('guideDoneStageNumber', '3');
                    localStorage.setItem('guideDone', 'true');
                },
                (err: any) => {
                    // this.showErrorFun(err.response.data.message);
                }
            );
        }
    }

    funHideMapRoute() {
        this.ishideMapRoute = !this.ishideMapRoute;
    }

    contactUnisSupport() {
        this.$modal.show(this.editContactUnisSupport);
    }

    closeReset() {
        this.$modal.hide(this.editContactUnisSupport);
        this.$modal.hide(this.editSchedulEdeliveryAppointment);
    }

    appointment: any = {};
    Cancel() {
        this.$modal.hide(this.editContactUnisSupport);
        this.$modal.hide(this.editSchedulEdeliveryAppointment);
        this.appointment = {};
    }

    sendContactSupport() {
        if (this.sendContactSupportNumber == 0) {
            this.sendContactSupportNumber = this.sendContactSupportNumber + 1;
        }
        // this.$modal.hide(this.editContactUnisSupport);
    }
    onSchedulEdeliveryAppointment() {
        this.$modal.show(this.editSchedulEdeliveryAppointment);
    }

    sendScheduleAppointment() {
        this.appointment.order_id = this.trackedShipment.order_id;
        tmsServiceBackend
            .post(`/cpv2/tracking/updateOrderScheduleDeliveryTime`, qs.stringify(this.appointment))
            .then(
                (res: any) => {},
                (err: any) => {
                    this.err(err.response.data.statusText);
                }
            );
        this.$modal.hide(this.editSchedulEdeliveryAppointment);
    }

    beforeRouteLeave(to: any, from: any, next: any) {
        localStorage.removeItem('TrackShipmentOrder');
        localStorage.removeItem('TrackShipmentTrackingNo');
        localStorage.removeItem('TrackShipmentQuerymodle');
        next();
    }

    openContactupportModel(
        data: Partial<{
            pro_or_pu: string;
        }> = {}
    ) {
        // @ts-ignore
        window.contactupport(data);
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!./src/layouts/trackingGuest/index.ts